<template>
  <SupplyForm
    class="mt-5 mb-5"
    pageTitle="Editar fertilizante"
    supplyType="fertilizer"
    submitButtonText="EDITAR FERTILIZANTE"
    :editMode="true"
    @dataFormValid="editFertilizerSupply"
  />
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage } from "naive-ui";
import supplyStore from "../../../store/supply";
import authStore from "../../../store/auth";
import SupplyForm from "../../../components/SuppliesComponents/supplyForm.vue";

export default {
  data() {
    return {
      message: useMessage(),
    };
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
  },
  computed: {
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(supplyStore, ["updateSupply"]),
    async editFertilizerSupply(newSupply) {
      try {
        await this.updateSupply(this.$route.params.id, newSupply);
        this.message.success("Suministro editado correctamente");
        this.$router.push("/app/supplies/fertilizer/list");
      } catch (err) {
        console.error(err);
      }
    },
  },
  components: { SupplyForm },
};
</script>
